<div class="fs-6 fw-bold c-footer text-muted text-center text-md-end d-flex flex-row flex-nowrap justify-content-end">
	<div *ngIf="footerText" [innerHTML]="footerText"></div>
	<ng-content></ng-content>
</div>
